(function (angular) {
    var UploadStatus;
    (function (UploadStatus) {
        UploadStatus["Pending"] = "Pending";
        UploadStatus["Fail"] = "Fail";
        UploadStatus["Completed"] = "Completed";
    })(UploadStatus || (UploadStatus = {}));
    var PhotoDialogController = /** @class */ (function () {
        function PhotoDialogController($scope, $mdDialog, AttackmentService, $files, $q, Upload, MKioskService, $ionicScrollDelegate, $timeout, CameraService) {
            this.$scope = $scope;
            this.$mdDialog = $mdDialog;
            this.AttackmentService = AttackmentService;
            this.$files = $files;
            this.$q = $q;
            this.Upload = Upload;
            this.MKioskService = MKioskService;
            this.$ionicScrollDelegate = $ionicScrollDelegate;
            this.$timeout = $timeout;
            this.cameraService = CameraService;
            
            this.photoRandomIndex = 0;
            this.filesUploadCompleted = 0;
            this.messages = {
                uploadFail: false,
                uploadPending: false,
                filesIsEmpty: false
            };
            //create canvas
            this.canvas = document.createElement("canvas");
            this.context = this.canvas.getContext("2d");
            
            this.canvas2 = document.createElement("canvas");
            this.context2 = this.canvas2.getContext("2d");
            
            this.watch();
            this.bindEventsOnScope();
        }
        PhotoDialogController.prototype.ready = function () {
            var _this = this;
            this.$element = $("#internal-add-event-v2-attackments-page");
            this.fileItemWidth = this.getFileItemWidth();
            this.resizeScrollbar(function () {
                _this.bindEvenetsOnElement();
            });
        };
        PhotoDialogController.prototype.onBeforeReady = function () {
            //Get Total files upload completed
            this.filesUploadCompleted = this.getFilesUploadStatus(this.$files, UploadStatus.Completed).length;
            //Update message when status was changed
            this.updateMessages(this.$files);
        };
        PhotoDialogController.prototype.watch = function () {
            var _this = this;
            this.$scope.$watchCollection("vm.$files", function (newValues, oldValues) {
                if (newValues !== oldValues) {
                    _this.filesUploadCompleted = _this.getFilesUploadStatus(newValues, UploadStatus.Completed).length;
                    //Update message when status was changed
                    _this.updateMessages(newValues);
                }
            });
        };
        PhotoDialogController.prototype.bindEvenetsOnElement = function () {
            var _this = this;
            //Resize scrollbar when toggle message
            this.$element.find(".messages").resize(function () {
                _this.resizeScrollbar(function () {
                    //go to top
                    _this.getScrollerDelegate().resize();
                });
            });
        };
        PhotoDialogController.prototype.bindEventsOnScope = function () {
            var _this = this;
            //Resize scrollbar and scrollTop when user chose files
            this.$scope.$on("uploadFiles", function () {
                if (_this.$element) {
                    _this.resizeScrollbar(function () {
                        //go to top
                        _this.getScrollerDelegate().scrollTop();
                    });
                }
            });
            this.$scope.$on("upload_completed", function () {
                _this.filesUploadCompleted = _this.getFilesUploadStatus(_this.$files, UploadStatus.Completed).length;
                //Update message when status was changed
                _this.updateMessages(_this.$files);
            });
            this.$scope.$on("upload_fail", function () {
                //Update message when status was changed
                _this.updateMessages(_this.$files);
            });
            //Release memory when close page
            this.$scope.$on("$destroy", function () {
                _.map(_this.$files, function ($file) {
                    _this.releaseFile($file);
                });

                // Release canvas
                $(_this.canvas).remove();
                $(_this.canvas2).remove();
                delete _this.context;
                delete _this.context2;
                delete _this.canvas;
                delete _this.canvas2;
            });
        };
        PhotoDialogController.prototype.onCancel = function () {
            this.$mdDialog.cancel();
        };
        PhotoDialogController.prototype.getStatus = function ($file) {
            var classes = [];
            switch ($file.uploadStatus) {
                case UploadStatus.Completed:
                    classes.push("upload-completed");
                    break;
                case UploadStatus.Fail:
                    classes.push("upload-fail");
                    break;
                case UploadStatus.Pending:
                    classes.push("upload-pending");
                    break;
            }
            return classes;
        };
        PhotoDialogController.prototype.getFileItemWidth = function () {
            var number = this.$element.find(".attachment-container").width() / 200;
            number = Math.round(number);
            if (number === 1)
                number = 2;
            return (1 / number) * 100;
        };
        PhotoDialogController.prototype.upload = function ($file) {
            var _this = this;
            //upload file
            var upload = this.MKioskService.uploadFile($file);
            upload.then(function (response) {
                if ($file.removed)
                    return;
                $file.AttachmentId = response.data.Id;
                $file.uploadStatus = UploadStatus.Completed;
                _this.$scope.$emit("upload_completed", $file);
                _this.safeApply();
            }, function () {
                if ($file.removed)
                    return;
                $file.uploadStatus = UploadStatus.Fail;
                _this.$scope.$emit("upload_fail", $file);
                _this.safeApply();
            }, function (evt) {
                if (evt.total > 0) {
                    $file.progress = Math.min(100, parseInt((100 * evt.loaded / evt.total).toString()));
                    _this.$scope.$emit("upload_in_progress");
                    _this.safeApply();
                }
            });
            //Abort upload
            upload['xhr'](function (xhr) {
                upload.abort = function () {
                    xhr.abort();
                };
            });
            $file.upload = upload;
            return upload;
        };
        PhotoDialogController.prototype.getThumbnail = function ($file) {
            return this.applyExifRotation($file, { width: 180 });
        };
        PhotoDialogController.prototype.applyTransform = function (ctx, orientation, width, height) {
            switch (orientation) {
                case 2:
                    return ctx.transform(-1, 0, 0, 1, width, 0);
                case 3:
                    return ctx.transform(-1, 0, 0, -1, width, height);
                case 4:
                    return ctx.transform(1, 0, 0, -1, 0, height);
                case 5:
                    return ctx.transform(0, 1, 1, 0, 0, 0);
                case 6:
                    return ctx.transform(0, 1, -1, 0, height, 0);
                case 7:
                    return ctx.transform(0, -1, -1, 0, height, width);
                case 8:
                    return ctx.transform(0, -1, 1, 0, 0, width);
            }
        };
        PhotoDialogController.prototype.calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
            var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
                Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
            return {
                width: srcWidth * ratio, height: srcHeight * ratio,
                marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
            };
        };
        PhotoDialogController.prototype.getOrientation = function (file) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                if (file.type.indexOf('image/jpeg') !== 0) {
                    resolve(0);
                }
                _this.Upload.readOrientation(file).then(function (result) {
                    resolve(result.orientation);
                }, function (e) {
                    reject(e);
                });
            });
        };
        PhotoDialogController.prototype.resizeAndRotate = function (url, orientation, options) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var img = new Image();
                img.onload = function () {
                    try {
                        var imgWidth = img.width, imgHeight = img.height, centerCrop = options.centerCrop, width = options.width, height = options.height;
                        if (!width) {
                            width = imgWidth;
                        }
                        if (!height) {
                            height = imgHeight;
                        }
                        var dimensions = _this.calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop), resizeWidth = Math.min(dimensions.width, width), resizedHeight = Math.min(dimensions.height, height);
                        //Reisze image
                        var canvas = _this.canvas, ctx = _this.context;
                        canvas.width = resizeWidth;
                        canvas.height = resizedHeight;
                        //@ts-ignore
                        ctx.drawImage(img, 0, 0, resizeWidth, resizedHeight);
                        var neededRotation = false;
                        if (orientation >= 2 && orientation <= 8) {
                            neededRotation = true;
                        }
                        var dataUrl = "";
                        if (neededRotation) {
                            //Rotate image
                            var canvasRotate = _this.canvas2, ctxRotate = _this.context2;
                            canvasRotate.width = orientation > 4 ? resizedHeight : resizeWidth;
                            canvasRotate.height = orientation > 4 ? resizeWidth : resizedHeight;
                            _this.applyTransform(ctxRotate, orientation, resizeWidth, resizedHeight);
                            //@ts-ignore
                            ctxRotate.drawImage(canvas, 0, 0);
                            dataUrl = canvasRotate.toDataURL('image/WebP', 0.934);
                        }
                        else {
                            dataUrl = canvas.toDataURL('image/WebP', 0.934);
                        }
                        var blob = _this.Upload.dataUrltoBlob(dataUrl), thumbnail = URL.createObjectURL(blob);
                        resolve({
                            thumbnail: thumbnail,
                            orientation: orientation,
                            neededRotation: neededRotation,
                            fileUrl: url
                        });
                    }
                    catch (e) {
                        return reject(e);
                    }
                };
                img.onerror = function (e) {
                    reject(e);
                };
                img.src = url;
            });
        };
        PhotoDialogController.prototype.applyExifRotation = function (file, options) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                _this.getOrientation(file).then(function (orientation) {
                    _this.Upload.dataUrl(file).then(function (url) {
                        _this.resizeAndRotate(url, orientation, options).then(resolve, reject);
                    }, function (e) {
                        reject(e);
                    });
                }, function (e) {
                    reject(e);
                });
            });
        };
        PhotoDialogController.prototype.renderThumbnail = function (imageList, index, callback) {
            var _this = this;
            var $file = imageList[index];
            this.getThumbnail(imageList[index]).then(function (result) {
                $file.thumbnail = result.thumbnail;
                $file.fileUrl = result.fileUrl;
                $file.orientation = result.orientation;
                $file.neededRotation = result.neededRotation;
                if ($file.thumbnailOnLoaded)
                    $file.thumbnailOnLoaded();
                _this.safeApply(function () {
                    if (index === imageList.length - 1) {
                        callback();
                    }
                    else {
                        _this.renderThumbnail(imageList, index + 1, callback);
                    }
                });
            });
        };
        PhotoDialogController.prototype.renderThumbnails = function (imageList) {
            var deferred = this.$q.defer();
            if (imageList.length > 0) {
                this.renderThumbnail(imageList, 0, function () {
                    deferred.resolve();
                });
            }
            else {
                deferred.resolve();
            }
            return deferred.promise;
        };
        PhotoDialogController.prototype.uploadFiles = function ($files) {
            var _this = this;
            _.each($files, function ($file) {
                if ($file.uploadStatus === UploadStatus.Pending)
                    _this.upload($file);
            }, this);
        };
        PhotoDialogController.prototype.uploadEventFiles = function ($files) {
            var _this = this;
            if ($files.length == 0)
                return;
            //Push to list
            _.each($files, function ($file) {
                $file.iconClass = _this.AttackmentService.getIcon($file.name);
                $file.isPhoto = _this.AttackmentService['isPhoto']($file.name);
                $file.Id = _.uniqueId("file_id");
                $file.AttachmentName = _this.getAttachmentName($file);
                $file.uploadStatus = UploadStatus.Pending;
                $file.progress = 0;
                //turn fail when filesize is 0
                if ($file.size === 0) {
                    $file.uploadStatus = UploadStatus.Fail;
                    $file.isPhoto = false;
                }
                _this.$files.splice(0, 0, $file);
            }, this);
            this.$scope.$emit("uploadFiles");
            this.safeApply();
            //render thumbnail
            var imageList = [];
            _.each($files, function ($file) {
                if ($file.isPhoto) {
                    imageList.push($file);
                }
            }, this);
            this.renderThumbnails(imageList.reverse()).then(function () {
                //Upload files
                _this.$timeout(500).then(function () {
                    _this.uploadFiles($files);
                });
            });
        };
        PhotoDialogController.prototype.releaseFile = function ($file) {
            try {
                $file.removed = true;
                //Cancel upload
                if ($file.upload) //Fix if file size is 0
                    $file.upload.abort();
                if ($file.thumbnail)
                    URL.revokeObjectURL($file.thumbnail);
                if ($file.fileUrl)
                    URL.revokeObjectURL($file.fileUrl);
            }
            catch (e) {
                console.log(e);
            }
        };
        PhotoDialogController.prototype.removeAttachmentFile = function ($file) {
            var _this = this;
            for (var i = 0; i < this.$files.length; i++) {
                if (this.$files[i].Id === $file.Id) {
                    this.$files.splice(i, 1);
                    break;
                }
            }
            console.log('Remove photo:', $file.name);
            this.releaseFile($file);
            
            if(this.$files.length > 0) {
                this.resizeScrollbar(function () {
                    _this.getScrollerDelegate().resize();
                });
            }
        };
        PhotoDialogController.prototype.replaceAll = function (target, search, replacement) {
            return target.split(search).join(replacement);
        };
        PhotoDialogController.prototype.removeSpecialCharacter = function (fileName) {
            return this.replaceAll(fileName, "+", "-");
        };
        PhotoDialogController.prototype.getAttachmentName = function ($file) {
            var fileName = $file.name;
            if ($file.isPhoto) {
                var ext = fileName.substr(fileName.lastIndexOf('.') + 1);
                this.photoRandomIndex++;
                fileName = "photo" + this.photoRandomIndex + "." + ext;
            }
            return this.removeSpecialCharacter(fileName);
        };
        PhotoDialogController.prototype.safeApply = function (fn) {
            var phase = this.$scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            }
            else {
                this.$scope.$apply(fn);
            }
        };
        PhotoDialogController.prototype.getScrollerDelegate = function () {
            return this.$ionicScrollDelegate.$getByHandle("addevent-v2-picture-scoller-handle");
        };
        PhotoDialogController.prototype.resizeScrollbar = function (callback) {
            var _this = this;
            this.$timeout(function () {
                var scroller = _this.$element.find("ion-scroll");
                scroller.css("height", "auto");
                scroller.height(scroller.parent().height());
                if (callback)
                    callback();
            });
        };
        PhotoDialogController.prototype.getFilesUploadStatus = function (files, uploadStatus) {
            return _.where(files, {
                uploadStatus: uploadStatus
            });
        };
        PhotoDialogController.prototype.updateMessages = function (files) {
            //Show error when status was changed
            this.messages.uploadFail = this.getFilesUploadStatus(files, UploadStatus.Fail).length > 0;
            this.messages.uploadPending = !this.messages.uploadFail && this.getFilesUploadStatus(files, UploadStatus.Pending).length > 0 && this.$scope.isShowPending;
            this.messages.filesIsEmpty = this.$files.length === 0 && this.$scope.isShowPending;
        };
        PhotoDialogController.prototype.showPhotosOrDocuments = function ($event) {
            this.cameraService
                .showPhotosOrDocumentsPanel($event, {
                    onStart: () => {},
                    acceptOnlyPicture: false
                })
                .then((data) => {
                    if (data) { // have file
                        if (!Array.isArray(data)) { // Convert to array if have a file
                            data = [data];
                        }
                        if (data.length > 0) {
                            this.uploadEventFiles(data);
                        }
                    }
                });
        };
        return PhotoDialogController;
    }());
    var AddEventCtrl = /** @class */ (function () {
        /**
         * 
         * @param $scope
         * @param $state
         * @param $stateParams
         * @param $mdDialog
         * @param MKioskService
         * @param $message
         * @param $timeout
         * @param $mdPanel{$mdPanel}
         * @param localStorageService
         * @param AttackmentService
         * @param $q
         * @param Upload
         * @param $ionicScrollDelegate
         * @param $Loading{$Loading}
         * @param $translationService
         * @param CameraService
         * @constructor
         */
        function AddEventCtrl($scope, $state, $stateParams, $mdDialog, MKioskService, $message, $timeout, $mdPanel, localStorageService, AttackmentService, $q, Upload, $ionicScrollDelegate, $Loading, $translationService, CameraService) {
            var _this = this;
            this.$scope = $scope;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$mdDialog = $mdDialog;
            this.MKioskService = MKioskService;
            this.$message = $message;
            this.$timeout = $timeout;
            this.$mdPanel = $mdPanel;
            this.localStorageService = localStorageService;
            this.AttackmentService = AttackmentService;
            this.$q = $q;
            this.Upload = Upload;
            this.$ionicScrollDelegate = $ionicScrollDelegate;
            this.$Loading = $Loading;
            this.$translationService = $translationService;
            this.cameraService = CameraService;

            this.uploadProgress = 0;
            this.vehicles = [];
            this.availableVehicles = []; // NF-807: this list is for apply default selection of car or showing list of cars

            this.$scope.vm = this;
            this.$element = $("#internal-add-event-v2-page");
            this.item = {
                Date: moment().format("YYYY-MM-DD")
            };
            this.eventTypes = [];
            this.$files = [];
            this.photoScope = this.$scope.$new(true);
            this.homeChargers = [];
            this.photoScope.vm = new PhotoDialogController(this.photoScope, this.$mdDialog, this.AttackmentService, this.$files, this.$q, this.Upload, this.MKioskService, this.$ionicScrollDelegate, this.$timeout, this.cameraService);

            // NF-761: support show vehicles selection if more than one
            this.showVehiclesSelector = false;
            this.showHomeChargerSelector = false;
            
            this.isChoosing = false;// Determine photo is choosing ( for showing loading when choose)
 
            this.$Loading.show();
            this.loadData()
                .finally(()=>{
                    this.$Loading.hide();
                })
                .then(function (result) {
                    _this.eventTypes = result[0];
                    _this.vehicles = result[1];
                    _this.homeChargers = result[2];
    
                    //Set first item
                    var initialSlide = _this.findIndexLastCreatedEvent();
                    if (initialSlide !== -1) {
                        _this.eventType = _this.eventTypes[initialSlide];
                        _this.item.EventTypeId = _this.eventTypes[initialSlide].Id;
                    }
    
                    // Set default
                    _this.setDefaultValues();
                    
    
                    _this.$timeout(function () {
                        _this.createSwiper(initialSlide);
                    });
                });
            this.watch();
            this.bindEvents();
        }

        AddEventCtrl.prototype.setDefaultValues = function () {
            if (!this.eventType) {
                return;
            }

            // NF-807: need filter based on type of event allow using eletric or/and fuel car
            var allowElectricity = true;
            var allowFuel = true;
            this.availableVehicles = this.vehicles;
            if (this.eventType.IsHomeCharge || this.eventType.IsPublicCharge) {
                allowElectricity = true;
                allowFuel = false;
                this.availableVehicles = this.vehicles.filter((v) => v.UsesElectricity == true);

                // NF-794: in case IsHomeCharge we need to set cost =0 by default so that user dont need to input when check mandatory
                if (this.eventType.IsHomeCharge) {
                    this.item.Cost = 0;
                }

            } else if (this.eventType.IsRefueling ) {
                this.availableVehicles = this.vehicles.filter((v) => v.UsesFuel == true);
                allowFuel = true;
                allowElectricity = false;
            }            

            // default vehicle
            if (this.eventType.Vehicle === 'Hidden') {
                this.item.VehicleId = null;
                this.vehicle = null;
            } else {
                // if curently select one but not match electric or fule criterial then reset to null
                if (this.vehicle && this.vehicle.UsesElectricity != allowElectricity && this.vehicle.UsesFuel != allowFuel) {
                    this.item.VehicleId = null;
                    this.vehicle = null;
                }

                if (!this.vehicle) {
                    if (this.availableVehicles.length === 1) {
                        this.item.VehicleId = this.availableVehicles[0].Id;
                        this.vehicle = this.availableVehicles[0];
                    }
                }
            }

            // default home charger
            if (this.eventType.HomeCharger === 'Hidden') {
                this.item.HomeChargerId = null;
                this.homeCharger = null;
            } else {
                if (!this.homeCharger) {
                    if (this.homeChargers.length === 1) {
                        this.item.HomeChargerId = this.homeChargers[0].Id;
                        this.homeCharger = this.homeChargers[0];
                    }
                }
            }

            // reset client when we dont set client by default
            if (this.eventType.Client === 'Hidden') {
                this.item.Client = null;
                this.client = null;
            }
        }

        AddEventCtrl.prototype.watch = function () {
            var _this = this;
            /**
             * Update paid by when change EventTypeId
             */
            this.$scope.$watch("vm.item.EventTypeId", function (newValue) {
                var isPaidByDriver = false, isPaidByCompany = false, result = _.findWhere(_this.eventTypes, { Id: newValue });
                if (result) {
                    switch (result.DefaultInitiallyPaidBy) {
                        case "Company":
                            isPaidByCompany = true;
                            break;
                        case "Driver":
                            isPaidByDriver = true;
                            break;
                    }
                }
                if (isPaidByDriver) {
                    delete _this.item.DueDate;
                }
                if (isPaidByCompany) {
                    delete _this.item.PaidByMeOn;
                }

                _this.setDefaultValues();
            });
            /**
             * Set ClientName of item when change client
             */
            this.$scope.$watch("vm.client", function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue)
                        _this.item.Client = newValue.Name;
                    else {
                        delete _this.item.Client;
                    }
                }
            });
            // Update progress when files was changed
            this.$scope.$watchCollection("vm.$files", function (newEvents, oldEvents) {
                if (newEvents !== oldEvents)
                    _this.uploadProgress = _this.getUploadProgress();
            });
        };
        AddEventCtrl.prototype.bindEvents = function () {
            var _this = this;
            // Destroy photoScope when $scope is destroy
            this.$scope.$on("$destroy", function () {
                _this.photoScope.$destroy();
                if (_this.panelRef)
                    _this.panelRef.close();
            });
            this.$scope.$on("upload_in_progress", function () {
                _this.uploadProgress = _this.getUploadProgress();
            });
        };
        AddEventCtrl.prototype.back = function () {
            var rounterName = "internal.events";
            if (this.$stateParams.prevState)
                rounterName = this.$stateParams.prevState;
            this.$state.go(rounterName);
        };
        /**
         * 
         * @return {Promise<any>}
         */
        AddEventCtrl.prototype.loadData = function () {
            var listQ = [];
            listQ.push(this.MKioskService.getEventTypes());
            listQ.push(this.MKioskService.getEventVehicles());
            listQ.push(this.MKioskService.getMyHomeChargers());
            
            return this.$q.all(listQ);
        };
        AddEventCtrl.prototype.createSwiper = function (initialSlide) {
            var _this = this;
            var swiperContainer = this.$element.find('.swiper-container');
            this.swiper = new Swiper(swiperContainer[0], {
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                initialSlide: initialSlide,
                init: false,
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true
                },
                pagination: {
                    el: this.$element.find('.swiper-pagination')[0]
                },
                on: {
                    slideChange: function () {
                        var eventType = _this.eventTypes[_this.swiper.activeIndex];
                        _this.item.EventTypeId = eventType.Id;
                        _this.eventType = eventType;
                        _this.safeApply();
                    }
                }
            });
            this.swiper.init();
            swiperContainer.css("visibility", "visible");
        };
        AddEventCtrl.prototype.showDatePickerModal = function ($event, item, name, options) {
            var _this = this;
            var DatePickerDialogController = /** @class */ (function () {
                function DatePickerDialogController(mdPanelRef, date, options, onClose) {
                    this.mdPanelRef = mdPanelRef;
                    this.date = date;
                    this.onClose = onClose;
                    this.options = options;
                }
                DatePickerDialogController.prototype.onChange = function (key, value) {
                    if (key === "selected-day") {
                        var date = value.format("YYYY-MM-DD");
                        this.closePanel(date);
                    }
                };
                DatePickerDialogController.prototype.onTodayButtonClicked = function () {
                    var date = moment().format("YYYY-MM-DD");
                    this.closePanel(date);
                };
                DatePickerDialogController.prototype.onClearButtonClicked = function () {
                    //@ts-ignore
                    this.date = null;
                    this.closePanel(this.date);
                };
                DatePickerDialogController.prototype.closePanel = function (data) {
                    var _this = this;
                    this.mdPanelRef.close().then(function () {
                        _this.onClose(data);
                    });
                };
                DatePickerDialogController.prototype.onCancel = function () {
                    this.mdPanelRef.close();
                };
                return DatePickerDialogController;
            }());
            var config = {
                controller: DatePickerDialogController,
                controllerAs: 'vm',
                templateUrl: 'js/internal/addevent-v2/date.modal.html',
                targetEvent: $event,
                clickOutsideToClose: true,
                escapeToClose: true,
                hasBackdrop: true,
                panelClass: 'add-event-v2-date-panel',
                zIndex: 90,
                onDomAdded: function () {
                    $(".add-event-v2-date-panel").parent().addClass("add-event-v2-date-panel-container");
                },
                locals: {
                    onClose: function (date) {
                        item[name] = date;
                    },
                    date: moment(item[name], "YYYY-MM-DD"),
                    options: options
                }
            };
            this.$timeout(function () {
                _this.panelRef = _this.$mdPanel.create(config);
                _this.panelRef.open();
            }, 100);
        };

        AddEventCtrl.prototype.onShowVehicleSelector = function ($event) {
            
            var mainTarget = $($event.target).closest('md-card')[0];

            var _self = this;
            this.showVehicleModal(this.availableVehicles, this.vehicle, { target: mainTarget }, this.eventType.Vehicle === 'Optional').then(function (vehicle) {
                if (vehicle) {
                    _self.item.VehicleId = vehicle.Id;
                    _self.vehicle = vehicle;
                } else {
                    _self.item.VehicleId = null;
                    _self.vehicle = null;
                }
            });
        };

        AddEventCtrl.prototype.onShowHomeChargerSelector = function ($event) {
            
            var mainTarget = $($event.target).closest('md-card')[0];

            var _self = this;

            // Simulate same model as vehicle so that can show same style
            var chargerList = this.homeChargers.map(function(x ) {
                return {
                    Id: x.Id,
                    Model: x.Name
                }
            })
            this.showVehicleModal(chargerList, this.homeCharger, { target: mainTarget }, this.eventType.HomeCharger === 'Optional').then(function (homeCharger) {
                if (homeCharger) {
                    _self.item.HomeChargerId = homeCharger.Id;
                    _self.homeCharger = homeCharger;
                } else {
                    _self.item.HomeChargerId = null;
                    _self.homeCharger = null;
                }
                
            });

        };

        AddEventCtrl.prototype.showCostModal = function ($event) {
            var _this = this;
            var showDatePickerModal = function ($event, item, name, $options) {
                _this.showDatePickerModal($event, item, name, $options);
            };
            var CostDialogController = /** @class */ (function () {
                function CostDialogController($mdDialog, item, eventType) {
                    this.$mdDialog = $mdDialog;
                    this.item = item;
                    this.eventType = eventType;

                    this.isPaidByDriver = false;
                    this.isPaidByCompany = false;
                    this.isPaidByUndefined = false;
                    switch (this.eventType.DefaultInitiallyPaidBy) {
                        case "Company":
                            this.isPaidByCompany = true;
                            break;
                        case "Driver":
                            this.isPaidByDriver = true;
                            break;
                        default:
                            this.isPaidByUndefined = true;
                    }
                    if (this.isPaidByDriver) {
                        delete this.item.DueDate;
                    }
                    // NF-282: Remove PaidByMeOn if EventType is IsRefueling or IsPublicCharge
                    if (this.isPaidByCompany || this.eventType.IsRefueling || this.eventType.IsPublicCharge || this.eventType.IsHomeCharge) {
                        delete this.item.PaidByMeOn;
                    }
                    this.title = this.getTitle();
                }
                CostDialogController.prototype.submit = function () {
                    this.$mdDialog.hide(this.item);
                };
                CostDialogController.prototype.onCancel = function () {
                    this.$mdDialog.cancel();
                };
                CostDialogController.prototype.showDatePickerModal = function ($event, item, name, $options) {
                    showDatePickerModal($event, item, name, $options);
                };
                CostDialogController.prototype.getTitle = function () {
                    var title = 'Cost';
                    if (this.eventType.IsPublicCharge || this.eventType.IsHomeCharge) {
                        title = 'Energy';
                    }
                    if (this.eventType.IsRefueling) {
                        title = 'Fuel';
                    }
                    return title;
                };
                CostDialogController.prototype.focusDatePicker = function (name, $event) {
                    if (document.activeElement) {
                        document.activeElement['blur']();
                    }
                    this.showDatePickerModal($event, this.item, name);
                    // Remove focus
                    setTimeout(function () {
                        if ($event.target) {
                            $($event.target).closest('md-input-container').removeClass('md-input-focused');
                        }
                    }, 500);
                };
                return CostDialogController;
            }());
            var eventType = _.findWhere(this.eventTypes, { Id: this.item.EventTypeId });
            this.$mdDialog.show({
                targetEvent: $event,
                templateUrl: 'js/internal/addevent-v2/cost.modal.html',
                controllerAs: 'vm',
                controller: CostDialogController,
                clickOutsideToClose: false,
                focusOnOpen: true,
                escapeToClose: false,
                locals: {
                    item: _.clone(this.item),
                    eventType: eventType                    
                }
            }).then(function (item) {
                _this.item.Cost = item.Cost;
                _this.item.DueDate = item.DueDate;
                _this.item.PaidByMeOn = item.PaidByMeOn;
                _this.item.OdometerReading = item.OdometerReading;
                _this.item.Quantity = item.Quantity;
            });
        };
        AddEventCtrl.prototype.showPhotosModal = function ($event, isShowPending, isShowButtomUpload) {
            this.photoScope.isShowPending = isShowPending;
            this.photoScope.isShowButtomUpload = isShowButtomUpload;
            this.$mdDialog.show({
                targetEvent: $event,
                templateUrl: 'js/internal/addevent-v2/photos.modal.html',
                scope: this.photoScope,
                clickOutsideToClose: true,
                escapeToClose: true,
                preserveScope: true,
                locals: {
                    $files: this.$files
                },
                onComplete: function ($scope) {
                    $scope.vm.ready();
                },
                onShowing: function ($scope) {
                    $scope.vm.onBeforeReady();
                }
            });
        };
        AddEventCtrl.prototype.showClientsModal = function ($event) {            
            var _this = this;
            this.$mdDialog.show({
                controller: 'ClientSelectorV2Ctrl',
                templateUrl: 'js/shared/clientsselector-v2/clientsselector.view.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                fullscreen: false,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals: {
                    client: _this.client,
                    options: {
                        optional: _this.eventType.Client === 'Optional',
                        selectOnly: false
                    }
                },
                onComplete: function (scope) {
                    scope.vm.ready();
                }
            }).then(function (client) {
                _this.client = client;                
            });
        };
        AddEventCtrl.prototype.showDescriptionModal = function ($event) {
            var _this = this;
            var DescriptionDialogController = /** @class */ (function () {
                function DescriptionDialogController($mdDialog, description) {
                    this.$mdDialog = $mdDialog;
                    this.description = description;
                }
                DescriptionDialogController.prototype.submit = function () {
                    this.$mdDialog.hide(this.description);
                };
                DescriptionDialogController.prototype.onCancel = function () {
                    this.$mdDialog.cancel();
                };
                return DescriptionDialogController;
            }());
            this.$mdDialog.show({
                targetEvent: $event,
                templateUrl: 'js/internal/addevent-v2/description.modal.html',
                controllerAs: 'vm',
                controller: DescriptionDialogController,
                escapeToClose: false,
                clickOutsideToClose: false,
                focusOnOpen: true,
                locals: {
                    description: this.item.Description
                }
            }).then(function (description) {
                _this.item.Description = description;
            });
        };
        AddEventCtrl.prototype.submit = function ($event) {
            //clone item
            var item = _.clone(this.item);
            //Show files manager if files upload is pending or update fail
            if (this.isExistFileUploadFail() || this.isUploading()) {
                this.showPhotosModal($event, true, false);
                return;
            }
            //attack file and save
            this.attachFiles(item, this.$files);
            if (this.prepareData(item, this.eventType)) {                
                this.save(item);
            }
        };
        AddEventCtrl.prototype.save = function (item) {
            this.$Loading.show();

            // when the type config no need Vehicle then we remove before send to server
            if (this.eventType.Vehicle === 'Hidden') {
                item.VehicleId = null;
            }

            // when the type config no need Home charger then we remove before send to server
            if (this.eventType.HomeCharger === 'Hidden') {
                item.HomeChargerId = null;
            }

            // reset client when config hidden
            if (this.eventType.Client === 'Hidden') {
                item.Client = null;
            }

            var _this = this;
            return this.MKioskService.addEvent(item).then(function (newEvent) {
                _this.localStorageService.set("lastCreatedEvent", newEvent);
                _this.back();
            }, this.$message.error).finally(function () {
                _this.$Loading.hide();
            });
        };
        AddEventCtrl.prototype.attachFiles = function (item, $files) {
            item.Attachments = [];
            _.each($files, function ($file) {
                //@ts-ignore
                item.Attachments.push({
                    AttachmentId: $file.AttachmentId,
                    AttachmentName: $file.AttachmentName
                });
            }, this);
        };
        AddEventCtrl.prototype.isUploading = function () {
            var isUploading = false;
            _.each(this.$files, function ($file) {
                if ($file.uploadStatus === UploadStatus.Pending) {
                    isUploading = true;
                }
            });
            return isUploading;
        };
        AddEventCtrl.prototype.getUploadProgress = function () {
            var progress = 0;
            _.each(this.$files, function ($file) {
                progress = progress + $file.progress;
            });
            progress = (progress / (100 * this.$files.length)) * 100;
            return progress;
        };
        AddEventCtrl.prototype.isExistFileUploadFail = function () {
            var failed = false;
            _.each(this.$files, function ($file) {
                if ($file.uploadStatus === UploadStatus.Fail) {
                    failed = true;
                }
            });
            return failed;
        };
        AddEventCtrl.prototype.findIndexLastCreatedEvent = function () {
            var match = -1;
            if (this.eventTypes.length > 0) {
                var lastCreatedEvent = this.localStorageService.get("lastCreatedEvent");
                if (lastCreatedEvent) {
                    var id = lastCreatedEvent.EventType ? lastCreatedEvent.EventType.Id : lastCreatedEvent.EventTypeId;
                    var result = _.findIndex(this.eventTypes, {
                        Id: id
                    });
                    if (result === -1) {
                        match = 0;
                    } else {
                        match = result;
                    }
                }
                else {
                    match = 0;
                }
                return match;
            }
        };
        AddEventCtrl.prototype.safeApply = function (fn) {
            var phase = this.$scope.$root.$$phase;
            if (phase == '$apply' || phase == '$digest') {
                if (fn && (typeof (fn) === 'function')) {
                    fn();
                }
            }
            else {
                this.$scope.$apply(fn);
            }
        };
        AddEventCtrl.prototype.showErrorMessages = function (errors) {
            var header = this.$translationService.getTranslation('PlsFillRequiredFields');

            // var template = '<div>Please fill in all the required following fields:</div><ul class="error-messages"><li>' + errors.join("</li><li>") + "</li></ul>";
            var template = `<div>${header}</div><ul class="error-messages"><li>${errors.join("</li><li>")} </li></ul>`;
            var alert = this.$mdDialog.alert();
            alert.ok(this.$translationService.getTranslation('OK'));
            alert.htmlContent(template);
            this.$mdDialog.show(alert);
        };
        AddEventCtrl.prototype.prepareData = function (item, eventType) {
            
            // Remove DueDate, PaidByMeOn if  DefaultInitiallyPaidBy is "Company" or "Driver"
            var isPaidByCompany = false, isPaidByDriver = false;
            switch (this.eventType.DefaultInitiallyPaidBy) {
                case "Company":
                    isPaidByCompany = true;
                    break;
                case "Driver":
                    isPaidByDriver = true;
                    break;
            }
            if (isPaidByDriver) {
                delete item.DueDate;
            }
            // NF-282: Remove PaidByMeOn if EventType is IsRefueling or IsPublicCharge
            if (isPaidByCompany || eventType.IsRefueling || eventType.IsPublicCharge) {
                delete item.PaidByMeOn;
            }
            // Remove OdometerReading, Quantity If eventType is IsRefueling or IsPublicCharge (or HomeCharge NF-597)
            if (!(eventType.IsRefueling || eventType.IsPublicCharge || eventType.IsHomeCharge)) {
                delete item.OdometerReading;
                delete item.Quantity;
            }
            var errors = [];
            if (eventType.Vehicle == 'Mandatory'  && !item.VehicleId) {
                errors.push(this.$translationService.getTranslation("Vehicle"));
            }

            // Charge event and refueling event need to input Odo
            if (eventType.IsRefueling || eventType.IsPublicCharge || eventType.IsHomeCharge) {
                if (!item.OdometerReading) {
                    errors.push(this.$translationService.getTranslation('OdometerReading'));
                }
                if (!item.Quantity) {
                    errors.push(this.$translationService.getTranslation("Quantity"));
                }
            }
            
            if (eventType.IsRefueling || item.DueDate || item.PaidByMeOn) {
                if (!item.Cost) {
                    errors.push(this.$translationService.getTranslation("Cost"));
                }
            }
            if (eventType.Client == 'Mandatory' && !item.Client) {
                errors.push(this.$translationService.getTranslation("Client"));
            }

            // NF-742: when home charger mandatory
            if (eventType.HomeCharger == 'Mandatory' && !item.HomeChargerId) {
                errors.push(this.$translationService.getTranslation("HomeCharger"));
            }

            // NF-1397: Allow an Event Type to require at least one supporting document
            if (eventType.IsSupportingDocumentRequired && (!item.Attachments || item.Attachments.length === 0)) {
                errors.push(this.$translationService.getTranslation("msgYouMustProvideAtLeastOneSupportingDocument"));
            }

            if (errors.length > 0) {
                this.showErrorMessages(errors);
            }
            return !(errors.length > 0);
        };

        AddEventCtrl.prototype.getPosition = function(element, number, itemHeight){
            let offset = $(element).offset();
            let top = offset.top + $(element).height();
            let position = this.$mdPanel.newPanelPosition().absolute().left(offset.left);
            // top=0;
            let belowHeight = $(window).height() - offset.top - $(element).height();
            if(belowHeight>=number*itemHeight){
                position =position.top(top);
            } else{
                position =position.centerVertically();
            }
            return position;
        }
        // This method use to show vehicle and also home charger selector
        AddEventCtrl.prototype.showVehicleModal = function (vehicles, vehicle, $event, optional = false) {
            var _this = this;
            var VehicleDialogController = /** @class */ (function () {
                function VehicleDialogController(mdPanelRef, vehicles, vehicle, onClose, width) {
                    this.mdPanelRef = mdPanelRef;
                    this.vehicles = vehicles;
                    this.vehicle = vehicle;
                    this.onClose = onClose;
                    this.width = width;
                    this.optional = optional;
                }
                VehicleDialogController.prototype.selectVehicle = function (vehicle) {
                    this.closePanel(vehicle);
                };
                VehicleDialogController.prototype.closePanel = function (data) {
                    var _this = this;
                    this.mdPanelRef.close().then(function () {
                        _this.onClose(data);
                    });
                };
                return VehicleDialogController;
            }());
            return this.$q(function (resolve) {
                var config = {
                    controller: VehicleDialogController,
                    controllerAs: 'vm',
                    templateUrl: 'js/internal/addevent-v2/vehicles.modal.html',
                    clickOutsideToClose: true,
                    escapeToClose: true,
                    zIndex: 90,
                    locals: {
                        onClose: function (vehicle) {
                            resolve(vehicle);
                        },
                        vehicles: vehicles,
                        vehicle: vehicle,
                        width: $($event.target).width()
                    },
                    position: _this.getPosition($event.target, vehicles.length+(optional?1:0), 76)
                };
                _this.$timeout(function () {
                    _this.panelRef = _this.$mdPanel.create(config);
                    _this.panelRef.open();
                }, 100);
            });
        };

        AddEventCtrl.prototype.showPhotosOrDocuments = function ($event) {
            this.cameraService
                .showPhotosOrDocumentsPanel($event, {
                    onStart: () => {
                        this.isChoosing = true; // Show loading when choosing file
                    },
                    acceptOnlyPicture: false
                })
                .then((data) => {
                    if (data) { // have file
                        if (!Array.isArray(data)) { // Convert to array if have a file
                            data = [data];
                        }
                        if (data.length > 0) {
                            this.photoScope.vm.uploadEventFiles(data);
                        }
                    }
                })
                .finally(() => {
                    this.isChoosing = false; // Hide loading if choose file complete
                });
        };
        AddEventCtrl.$inject = ['$scope', '$state', '$stateParams', '$mdDialog', 'MKioskService', '$message', '$timeout', '$mdPanel', 'localStorageService',
            'AttackmentService', '$q', 'Upload', '$ionicScrollDelegate', '$Loading', '$translationService', 'CameraService'];
        return AddEventCtrl;
    }());
    angular.module('internal.addevent-v2').controller('AddEventV2Ctrl', AddEventCtrl);
}(angular));
